<template>
    <v-form ref="formFiltro" class="filtros-acordos">
        <v-divider class="mt-2 mb-3"></v-divider>
        <v-row>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <MesInput
                    label="Período Inicial"
                    v-model="filtro.mesInicial"
                    :rules="regra.mesInicial"
                    :change="periodoInicialChange"
                    required
                ></MesInput>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <MesInput
                    label="Período Final"
                    v-model="filtro.mesFinal"
                    :rules="regra.mesFinal"
                    :change="periodoFinalChange"
                    required
                ></MesInput>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <v-text-field
                    label="Número do acordo"
                    outlined
                    dense
                    class="input-cinza"
                    v-model="filtro.id_acordo_gc"
                ></v-text-field>
            </v-col>
            <v-col sm="6" md="4" lg="3" class="pb-0">
                <v-text-field
                    label="Número do contrato"
                    outlined
                    dense
                    class="input-cinza"
                    v-model="filtro.id_contrato_gc"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-expansion-panels flat v-model="mostrarFiltros" accordion>
            <v-expansion-panel>
                <v-expansion-panel-content eager class="p-0 m-0">
                    <v-row>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Cluster/Rede"
                                v-model="filtro.cluster_rede"
                                :items="lista.cluster_rede"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Espaço GC"
                                v-model="filtro.id_espaco_gc"
                                :items="lista.espacoGC"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Categoria"
                                v-model="filtro.id_categoria"
                                :items="lista.categorias"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
                            </SelectInput>
                        </v-col>
                        <v-col sm="6" md="4" lg="3" class="pb-0">
                            <SelectInput
                                label="Status"
                                :items="lista.status"
                                v-model="filtro.id_status"
                                multiple
                                :menu-props="menuProps"
                                outlined
                                dense
                                class="input-cinza"
                                show-select-all
                            >
                            </SelectInput>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-divider class="mt-0 mb-3"></v-divider>
        <v-row>
            <v-col cols="3" class="px-2 ml-auto">
                <div class="new-button d-flex align-center" text>
                    <span @click="expandirFiltros" style="cursor: pointer"
                        >Personalizar Filtros</span
                    >
                    <v-btn
                        style="background: #e6e6e6; width: 20px; height: 20px"
                        fab
                        icon
                        class="ml-3"
                        @click="expandirFiltros"
                        x-small
                    >
                        <v-icon>{{
                            mostrarFiltros == 0
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                        }}</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col cols="9" class="ml-auto" align="end">
                <v-btn
                    class="ml-2 new-button"
                    color="yellow"
                    dark
                    @click="limpar()"
                >
                    <v-icon left>mdi-filter-off</v-icon> Limpar Filtros
                </v-btn>
                <v-btn
                    class="ml-5 new-button"
                    color="primary"
                    @click="filtrar()"
                >
                    <v-icon left>mdi-filter</v-icon> Filtrar
                </v-btn>
            </v-col>
        </v-row>
        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-form>
</template>

<script>
export default {
    inject: ["listaCampos"],
    data() {
        return {
            carregando: false,
            mostrarFiltros: null,
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
            },
            lista: {
                espacoGC: [],
                categorias: [],
                cluster_rede: [],
                status: [],
            },
            filtro: {},
            regra: {
                mesInicial: [
                    (v) => !!v || "O campo período inicial é obrigatório",
                ],
                mesFinal: [
                    (v) => !!v || "O campo período final é obrigatório",
                    (v) =>
                        (!!v && v >= this.filtro.mesInicial) ||
                        "O período final deve ser igual ou posterior ao período inicial",
                ],
            },
        };
    },
    async created() {
        this.carregando = true;
        var lista = await this.listaCampos;
        lista.status = (lista.status || []).sort(function (a, b) {
            return (a.text || "").localeCompare(b.text || "");
        });
        this.lista.espacoGC = lista.espacoGC || [];
        this.lista.categorias = lista.categorias || [];
        this.lista.cluster_rede = lista.cluster_rede || [];
        this.lista.status = lista.status || [];
        this.iniciaFiltro();
        this.carregando = false;
    },
    methods: {
        iniciaFiltro() {
            this.filtro = {
                mesInicial: this.$moment().format("YYYY-MM"),
                mesFinal: this.$moment().format("YYYY-MM"),
                id_acordo_gc: null,
                id_contrato_gc: null,
                cluster_rede: [],
                id_espaco_gc: [],
                id_categoria: [],
                id_status: [],
            };
        },
        limpar() {
            this.iniciaFiltro();
            this.$emit("limpar");
        },
        filtrar() {
            this.$emit("filtrar");
        },
        validate() {
            return this.$refs.formFiltro.validate();
        },
        expandirFiltros() {
            this.mostrarFiltros = this.mostrarFiltros == 0 ? null : 0;
        },
        periodoInicialChange(valor) {
            if (this.filtro.mesFinal < valor) {
                this.filtro.mesFinal = valor;
            }
        },
        periodoFinalChange(valor) {
            if (this.filtro.mesInicial > valor) {
                this.filtro.mesInicial = valor;
            }
        },
        resetValidation() {
            try {
                this.$refs.formFiltro.resetValidation();
            } catch (error) {
                //console.log(error)
            }
        },
    },
};
</script>
